module.exports = __webpack_public_path__ + "../resources/img/ic-re-user-account-default.df6a9201.svg";